import createIcon from '../../createIcon';

/**
 * @component @name SwapHorizontalCircle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTJDMjIgNi40OCAxNy41MiAyIDEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMlpNMTUgNi41TDE4LjUgMTBMMTUgMTMuNVYxMUgxMVY5SDE1VjYuNVpNOSAxNy41TDUuNSAxNEw5IDEwLjVWMTNIMTNWMTVIOVYxNy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwapHorizontalCircle = createIcon('SwapHorizontalCircle', [
  [
    'path',
    {
      d: 'M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12ZM15 6.5L18.5 10L15 13.5V11H11V9H15V6.5ZM9 17.5L5.5 14L9 10.5V13H13V15H9V17.5Z',
      key: 'jyn0gb',
    },
  ],
]);

export default SwapHorizontalCircle;
